import useSocket from "@shared/features/socket/useSocket";
import { useDispatch } from "react-redux";
import { BotType, FiltersSliceState, SocketTopics } from "@shared/types";
import { SocketArgs } from "@shared/services/socket/types";
import { groupBy } from "lodash";
import { updateBotsData } from "@shared/features/bots/utils";
import { useEffect } from "react";
import { socketsSlices } from "@shared/slices/sockets.slice";
import {
  BOT_STATUS_TO_HIDE,
  BOT_TYPE_TO_FILTERS_SLICE,
} from "@shared/features/bots/constants";
import { updateBotsFilters } from "@shared/features/filters/utils";

const useSocketAggBotData = (
  socketArgs: SocketArgs<SocketTopics.AGG_BOTS>,
  refetchBotsData?: () => void
) => {
  const dispatch = useDispatch();

  const socketData = useSocket<SocketTopics.AGG_BOTS>(
    SocketTopics.AGG_BOTS,
    socketArgs
  );

  useEffect(() => {
    const socketBotsData = socketData?.value;
    if (socketBotsData) {
      dispatch(
        socketsSlices[SocketTopics.AGG_BOTS].actions.updateSocketData(undefined)
      );
      if ("fetch_initial_data" in socketBotsData) {
        try {
          refetchBotsData?.();
        } catch {}
      } else {
        const botTypeToBots = groupBy(socketBotsData, (bot) => bot.bot_type);
        Object.entries(botTypeToBots).forEach(([botTypeStr, updatedBots]) => {
          if (!updatedBots.length) return;
          const botType = parseInt(botTypeStr) as BotType;
          dispatch(updateBotsData(updatedBots, botType) as any);
          const filtersSlice = BOT_TYPE_TO_FILTERS_SLICE[botType];
          const visibleBots = updatedBots.filter(
            (b) => !BOT_STATUS_TO_HIDE.includes(b.status)
          );
          if (visibleBots.length) {
            dispatch(
              filtersSlice.actions.updateFilters({
                filtersUpdateFunction: (state: FiltersSliceState) =>
                  updateBotsFilters(state, visibleBots),
              })
            );
          }
        });
      }
    }
  }, [socketData]);
};

export default useSocketAggBotData;
